
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryNavigationItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pathSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryImageFileName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"englishCategoryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoLongTitleName"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChildNavigationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductCategoryChildNavigationItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryImages"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"imageFileName"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pathSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryImageFileName"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"englishCategoryName"},"name":{"kind":"Name","value":"englishName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoLongTitleName"},"arguments":[],"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavigationTreeItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryNavigationTreeItem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryDisplayName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryIdPath"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryPathSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"selected"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"categoryEnglishDisplayName"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":664}};
    doc.loc.source = {"body":"fragment NavigationItem on CategoryNavigationItem {\n  categoryId\n  hits\n  selected\n  category {\n    name\n    pathSlug\n    categoryImageFileName\n    englishCategoryName\n    seoLongTitleName\n  }\n}\n\nfragment ChildNavigationItem on ProductCategoryChildNavigationItem {\n  categoryId\n  hits\n  selected\n  category {\n    categoryImages {\n      imageFileName\n    }\n    name\n    pathSlug\n    categoryImageFileName\n    englishCategoryName: englishName\n    seoLongTitleName\n  }\n}\n\nfragment NavigationTreeItem on CategoryNavigationTreeItem {\n  categoryId\n  categoryDisplayName\n  categoryIdPath\n  categoryPathSlug\n  hits\n  selected\n  ticket\n  url\n  categoryEnglishDisplayName\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["NavigationItem"] = oneQuery(doc, "NavigationItem");
        
        module.exports["ChildNavigationItem"] = oneQuery(doc, "ChildNavigationItem");
        
        module.exports["NavigationTreeItem"] = oneQuery(doc, "NavigationTreeItem");
        
